// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-810cc6da] {\n  color: gray;\n  font-weight: 300;\n}\n.image-preview[data-v-810cc6da] {\n  padding: 12px;\n  min-height: 200px;\n  background-color: #eaeaea;\n}\n.image-preview[data-v-810cc6da],\ninput[type=file][data-v-810cc6da] {\n  width: 420px;\n  max-width: 420px;\n}", ""]);
// Exports
module.exports = exports;
